import { useSelector } from "react-redux";
import SortableTree, { walk } from "react-sortable-tree";
import store from "../../stores/store";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import CustomNodeContentRenderer from "../layerTree/CustomNodeContentRenderer";
import { useEffect, useState } from "react";
import { trans } from "../../lib/utils";

function LayerConfiguration(props) {
  const layers = useSelector((state) => store.getState().layers);

  const [searchQuery, setSearchQuery] = useState(null);

  const [treeData, setTreeData] = useState([]);

  const [layerAttribute, setLayerAttribute] = useState(
    props.layer.attributes ? props.layer.attributes : []
  );

  const [layerTitle, setLayerTitle] = useState(props.layer.title);
  const [layerAbstract, setLayerAbstract] = useState(props.layer.abstract);

  useEffect(() => {
    setTreeData(formatAttributes(layerAttribute));
  }, []);

  const updateAttribute = (idx, property, value) => {
    let updatedLayerAttributes = [
      ...treeData.map((el) => {
        return el.attribute;
      }),
    ];

    updatedLayerAttributes[idx][property] = value;

    // setLayerAttribute(updatedLayerAttributes);

    setTreeData(formatAttributes(updatedLayerAttributes));
  };

  const saveConfiguration = () => {
    let formattedAttributes = [];

    walk({
      treeData: treeData,
      getNodeKey: ({ treeIndex }) => treeIndex,
      ignoreCollapsed: true,
      callback: (rowInfoIter) => {
        let attribute = rowInfoIter.node.attribute;
        formattedAttributes.push({
          name: attribute.name,
          title: attribute.title,
          value: null,
          editor: attribute.type,
          sortable: attribute.sortable,
          order: rowInfoIter.index,
          visible: attribute.visible,
          searchable: attribute.searchable,
          isGeometry: attribute.visible,
          isVisible: attribute.isVisible,
          showOnSummary: attribute.showOnSummary,
        });
      },
    });

    store.dispatch({
      type: "layer/update",
      payload: {
        property: "attributes",
        value: formattedAttributes,
        id: props.layer.id,
      },
    });

    store.dispatch({
      type: "layer/update",
      payload: { property: "title", value: layerTitle, id: props.layer.id },
    });

    store.dispatch({
      type: "layer/update",
      payload: {
        property: "abstract",
        value: layerAbstract,
        id: props.layer.id,
      },
    });
  };

  const formatAttributes = (attributes) => {
    let formattedAttributes = [];

    attributes.forEach((attribute, idx) => {
      formattedAttributes.push({
        id: attribute.name,
        title: attribute.title,
        expanded: true,
        attribute: {
          name: attribute.name,
          title: attribute.title,
          value: null,
          editor: attribute.type ? attribute.type : "text",
          sortable: attribute.sortable,
          order: idx,
          visible: attribute.visible,
          searchable: attribute.searchable,
          isGeometry: false,
          isVisible: attribute.isVisible,
          showOnSummary: attribute.showOnSummary,
        },
      });
    });

    return formattedAttributes;
  };

  const customSearchMethod = ({ node, searchQuery }) => {
    if (layers[node.id] && searchQuery && window["map"]) {
      return (
        layers[node.id]?.title
          ?.toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1 ||
        layers[node.id]?.name
          ?.toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1
      );
    }
    return true;
  };

  return (
    <div className="mt-2">
      <div className="mb-3">
        <div className="d-flex w-100">
          <div className="w-50">
            <label className="color-get-blue strong ">
              {trans("Layer Name")}
            </label>

            <div className="mt-1">
              <span className="text-secondary">
                {props.layer.name} ({props.layer.source.type})
              </span>
            </div>
          </div>
          <div className="text-end w-50">
            <button
              type="button"
              className="btn btn-sm btn-link border"
              onClick={saveConfiguration}
            >
              <i className="fas fa-save me-2"></i>
              {trans("Save Layer")}
            </button>
          </div>
        </div>
      </div>
      <div className="text-end"></div>
      <div className="input-group">
        <span className="input-group-text small">{trans("Layer Title")}</span>
        <input
          type="text"
          value={layerTitle}
          placeholder={trans("Set layer Title")}
          className="form-control form-control-sm"
          onChange={(e) => {
            setLayerTitle(e.target.value);
          }}
        ></input>
      </div>
      <div className="input-group mt-2">
        <span className="input-group-text small">
          {trans("Layer Abstract")}
        </span>
        <textarea
          value={layerAbstract}
          placeholder={trans("Set layer abstract")}
          className="form-control form-control-sm"
          onChange={(e) => {
            setLayerAbstract(e.target.value);
          }}
        ></textarea>
      </div>
      <div className="mt-2 mb-2">
        <div className="card">
          <div className="card-header">{trans("Layer attributes")}</div>
          <div className="card-body">
            <SortableTree
              treeData={treeData}
              isVirtualized={false}
              onMoveNode={(args) => {}}
              onChange={(_treeData) => {
                let formattedAttributes = [];

                walk({
                  treeData: _treeData,
                  getNodeKey: ({ treeIndex }) => treeIndex,
                  ignoreCollapsed: true,
                  callback: (rowInfoIter) => {
                    let attribute = rowInfoIter.node.attribute;

                    formattedAttributes.push({
                      id: attribute.name,
                      title: attribute.title,
                      expanded: true,
                      attribute: {
                        name: attribute.name,
                        title: attribute.title,
                        value: null,
                        editor: attribute.type,
                        sortable: attribute.sortable,
                        order: rowInfoIter.index,
                        visible: attribute.visible,
                        searchable: attribute.searchable,
                        isGeometry: attribute.visible,
                        isVisible: attribute.isVisible,
                        showOnSummary: attribute.showOnSummary,
                      },
                    });
                  },
                });

                setTreeData(formattedAttributes);
              }}
              searchQuery={searchQuery}
              searchMethod={customSearchMethod}
              nodeContentRenderer={CustomNodeContentRenderer}
              generateNodeProps={({ node, path, treeIndex }) => ({
                more: () => {
                  return null;
                },

                title: () => {
                  let attribute = treeData[treeIndex].attribute;
                  return (
                    <div>
                      <div>
                        <div className="color-grey small">
                          {trans("Name")}: {attribute.name}
                        </div>
                      </div>
                      <div className=" mt-2">
                        <div className="input-group">
                          <span className="input-group-text small">
                            {trans("Title")}
                          </span>
                          <input
                            type="text"
                            placeholder={trans("Set attribute title")}
                            className="form-control form-control-sm"
                            value={attribute.title}
                            onChange={(e) => {
                              updateAttribute(
                                treeIndex,
                                "title",
                                e.target.value
                              );
                            }}
                          ></input>
                          <span className="input-group-text ms-2 small">
                            {trans("Editor")}
                          </span>
                          <select
                            className="form-select form-select-sm "
                            value={attribute.editor}
                            onChange={(e) => {
                              updateAttribute(
                                treeIndex,
                                "editor",
                                e.target.value
                              );
                            }}
                          >
                            {window["appConfig"]()
                              ["editors"]()
                              .map((opt) => {
                                return <option value={opt}>{opt}</option>;
                              })}
                          </select>

                          <span className="input-group-text ms-2 small">
                            {trans("Searchable")}
                          </span>
                          <select
                            className="form-select form-select-sm "
                            value={attribute.searchable}
                            onChange={(e) => {
                              updateAttribute(
                                treeIndex,
                                "searchable",
                                e.target.value === "true" ? true : false
                              );
                            }}
                          >
                            <option value="true">{trans("Yes")}</option>
                            <option value="false">{trans("No")}</option>
                          </select>
                          <span className="input-group-text ms-2 small">
                            {trans("Visible")}
                          </span>
                          <select
                            className="form-select form-select-sm "
                            value={attribute.visible}
                            onChange={(e) => {
                              updateAttribute(
                                treeIndex,
                                "visible",
                                e.target.value === "true" ? true : false
                              );
                            }}
                          >
                            <option value="true">{trans("Yes")}</option>
                            <option value="false">{trans("No")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  );
                },
              })}
            ></SortableTree>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LayerConfiguration;
